// src/services/batchService.js
import { db } from "../firebase";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";

const batchesRef = collection(db, "batches");

export const getBatches = async () => {
  const snapshot = await getDocs(batchesRef);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
};

export const createBatch = async (batchData) => {
  const docRef = await addDoc(batchesRef, batchData);
  return docRef.id;
};

export const updateBatch = async (id, updatedData) => {
  const batchRef = doc(db, "batches", id);
  await updateDoc(batchRef, updatedData);
};

export const deleteBatch = async (id) => {
  const batchRef = doc(db, "batches", id);
  await deleteDoc(batchRef);
};
